<template>
  <div class="performance_box" v-if="userDetails.gamesPlayed > 0">

    <h1>{{ getTranslations.home_profile_profile_performance }}</h1>

    <div id="accordion">

      <div v-for="index in checkButton"  :key="index.type" >
        <!-- ALL GAMES -->
        <div class="performance_bg">

          <div class="accordion_top" role="button">
            <div class="performance_row_title">
              <h2>{{updateText(index)}}</h2>
            </div>
            <div class="performance_row_text">
              <p><span>{{ calculate(index)  }}% </span>{{ getTranslations.home_profile_profile_accuracy }}</p>
              <p><span>{ {{ dataWon[index-1] }}/{{ dataPlayed[index-1] }}   {{ getTranslations.home_profile_profile_correct }} )</span></p>
            </div>
            <div class="progressbar">
              <div class="progressbar__bar" :data-percent='calculate(index)'></div>
            </div>

          </div>

          <div class="slide">

            <div class="desktop_perf_block">

                <performance-circle :performance='putData(index)' :circles="4"/>
                <p v-if="showStatus[index-1]">{{ getTranslations.home_profile_profile_performance_in }} <span>“{{showBestPerformance()}}”</span> {{ getTranslations.home_profile_profile_outstanding }} </p>

            </div>

            <div class="mobile_perf_carousel">
              <div class="swiper">
                <div class="swiper-wrapper">


                  <performance-circle :performance='putData(index)'
                  :circles="4" :mobile="true"/>

                </div>
              </div>
              <p v-if="showStatus[index-1]"> {{ getTranslations.home_profile_profile_performance_in }} <span>“{{showBestPerformance()}}”</span> {{ getTranslations.home_profile_profile_outstanding }} </p>
            </div>
          </div>

        </div>
        <div class="perf_horizontal_line" ></div>

        <!-- EASY GAMES -->
      </div>

      <div class="load_more_btn" v-if="display">
        <button class="load-more btn2 btn2--std btn2--small" @click="buttonTrigger" >···</button>
      </div>

    </div>
  </div>
  <div class="performance_box empty" v-else>
    <h1>{{ getTranslations.home_profile_profile_your_performance }}</h1>
    <img src="/static/images/profile/profile-emptystate.png">
    <p>{{ getTranslations.home_profile_profile_empty }}</p>
  </div>

</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex';
import 'owl.carousel';
import { profileBar } from '@/common/jQuery';
import $ from 'jquery';
import PerformanceCircle from './PerformanceCircle';


export default {
  name: 'profile-performance',
  components: { PerformanceCircle },
  data() {
    return {
      dataWon: [0, 0, 0, 0],
      dataPlayed: [0, 0, 0, 0],
      respon: {},
      showStatus: [true, true, true, true],
      text: ['', '', '', ''],
      title: '',
      checkButton: 4,
      titleText: ['', '', '', ''],
      performannceStatus: [0.0, 0.0, 0.0, 0.0],
      index: 0,
      j: 4,
      bestPerformance: [''],
      display: false,
    };
  },
  mounted() {
    /* eslint-disable */
    profileBar();

    $('.owl-carousel').owlCarousel({
      loop: false,
      responsiveClass: true,
      autoplay: false,
      autoplayHoverPause: true,
      navContainer: '.carousel__nav',
      responsive: {
        321: {
          // centeredSlides: true,
          items: '2',
          nav: 0,
        },
        0: {
          items: '2',
          nav: 0,
        },

      }
    });

    $(".progressbar__bar").each(function (t, e) {
      var n = $(e).data("percent");
      $(e).width(n + "%")
    })
    $('.slide').hide();

    $("#accordion").find("div[role|='button']").click(function() {

      $("#accordion").find("div[role|='button']").removeClass('active');
      $('.slide').slideUp('fast');
      var selected = $(this).next('.slide');
      $(".accordion_top").parent().removeClass('selected')

      if (selected.is(":hidden")) {
        $(this).next('.slide').slideDown('fast');
        $(this).toggleClass('active');
        $(this).parent().addClass('selected').siblings().removeClass('selected');
      } else {
        $(this).parent().removeClass('selected');
      }

    });
  },
  created() {
    this.dataWon[0] = this.performanceInfo.miniGamesWon ;
    this.dataPlayed[0] = this.performanceInfo.miniGamesPlayed;
    this.dataWon[1] = this.performanceInfo.easyMiniGamesWon ;
    this.dataPlayed[1] = this.performanceInfo.easyMiniGamesPlayed;
    this.dataWon[2] = this.performanceInfo.hardMiniGamesWon ;
    this.dataPlayed[2] = this.performanceInfo.hardMiniGamesPlayed;
    this.dataWon[3] = this.performanceInfo.veryHardMiniGamesWon ;
    this.dataPlayed[3] = this.performanceInfo.veryHardMiniGamesPlayed;
    console.log('Load Profile');
    this.text[0] = this.getTranslations['home_profile_profile_all'];
    this.text[1] = this.getTranslations['home_profile_profile_easy'];
    this.text[2] = this.getTranslations['home_profile_profile_hard'];
    this.text[3] = this.getTranslations['home_profile_profile_very_hard'];
    this.titleText[0] = this.getTranslations['home_profile_profile_logic'];
    this.titleText[1] = this.getTranslations['home_profile_profile_memory'];
    this.titleText[2] = this.getTranslations['home_profile_profile_attention'];
    this.titleText[3] = this.getTranslations['home_profile_profile_rounder'];
  },
  methods: {
    ...mapActions('profile', [
      'storePerformance',
    ]),
    updateText(index) {
     return  this.text[index-1];
    },
    checkSum(index,data){
      let max = 0;
      max = Math.max(...data);
      let sum = 0;
      let position = -1;
      for (let i = 0; i < data.length; i++) {
        sum += data[i];
        if ( data[i] == max) {
          position = i;
        }
      }
      let value = 0;
      if( sum === 0 )
        this.showStatus[index-1] = false;
      else {
        this.bestPerformance[0] = this.titleText[position];
      }
    },
    calculate(index) {
      if (index === 1) {
        return this.performanceInfo.miniGamesAccuracy ? parseFloat(this.performanceInfo.miniGamesAccuracy).toFixed(2) : 0;
      }
      else if (index === 2) {
        return this.performanceInfo.easyMiniGamesAccuracy ? parseFloat(this.performanceInfo.easyMiniGamesAccuracy).toFixed(2) : 0;
      }
      else if (index === 3) {
        return this.performanceInfo.hardMiniGamesAccuracy ? parseFloat(this.performanceInfo.hardMiniGamesAccuracy).toFixed(2) : 0;
      }
      else if (index === 4) {
        return this.performanceInfo.veryHardMiniGamesAccuracy ? parseFloat(this.performanceInfo.veryHardMiniGamesAccuracy).toFixed(2) : 0;
      }
    },
    putData(index) {
      const data = [0, 0, 0, 0];
      if (index === 1) {
        data[0] = this.performanceInfo.logicMiniGamesAccuracy ? parseFloat(this.performanceInfo.logicMiniGamesAccuracy).toFixed(2) : 0;
        data[1] = this.performanceInfo.memoryMiniGamesAccuracy ? parseFloat(this.performanceInfo.memoryMiniGamesAccuracy).toFixed(2) : 0;
        data[2] = this.performanceInfo.attentionMiniGamesAccuracy ? parseFloat(this.performanceInfo.attentionMiniGamesAccuracy).toFixed(2) : 0;
        data[3] = this.performanceInfo.mixedMiniGamesAccuracy ? parseFloat(this.performanceInfo.mixedMiniGamesAccuracy).toFixed(2) : 0;
      }
      else if (index === 2) {
        data[0] = this.performanceInfo.easyLogicMiniGamesAccuracy ?parseFloat(this.performanceInfo.easyLogicMiniGamesAccuracy).toFixed(2) : 0;
        data[1] = this.performanceInfo.easyMemoryMiniGamesAccuracy ?parseFloat(this.performanceInfo.easyMemoryMiniGamesAccuracy).toFixed(2) : 0;
        data[2] = this.performanceInfo.easyAttentionMiniGamesAccuracy ?parseFloat(this.performanceInfo.easyAttentionMiniGamesAccuracy).toFixed(2) : 0;
        data[3] = this.performanceInfo.easyMixedMiniGamesAccuracy ?parseFloat(this.performanceInfo.easyMixedMiniGamesAccuracy).toFixed(2) : 0;
      }
      else if (index === 3) {
        data[0] = this.performanceInfo.hardLogicMiniGamesAccuracy ?parseFloat(this.performanceInfo.hardLogicMiniGamesAccuracy).toFixed(2) : 0;
        data[1] = this.performanceInfo.hardMemoryMiniGamesAccuracy ?parseFloat(this.performanceInfo.hardMemoryMiniGamesAccuracy).toFixed(2) : 0;
        data[2] = this.performanceInfo.hardAttentionMiniGamesAccuracy ?parseFloat(this.performanceInfo.hardAttentionMiniGamesAccuracy).toFixed(2) : 0;
        data[3] = this.performanceInfo.hardMixedMiniGamesAccuracy ?parseFloat(this.performanceInfo.hardMixedMiniGamesAccuracy).toFixed(2) : 0;
      }
      else if (index === 4) {
        data[0] = this.performanceInfo.veryHardLogicMiniGamesAccuracy ?parseFloat(this.performanceInfo.veryHardLogicMiniGamesAccuracy).toFixed(2) : 0;
        data[1] = this.performanceInfo.veryHardMemoryMiniGamesAccuracy ?parseFloat(this.performanceInfo.veryHardMemoryMiniGamesAccuracy).toFixed(2) : 0;
        data[2] = this.performanceInfo.veryHardAttentionMiniGamesAccuracy ?parseFloat(this.performanceInfo.veryHardAttentionMiniGamesAccuracy).toFixed(2) : 0;
        data[3] = this.performanceInfo.veryHardMixedMiniGamesAccuracy ?parseFloat(this.performanceInfo.veryHardMixedMiniGamesAccuracy).toFixed(2) : 0;
      }
      this.checkSum(index,data);
      return data;
    },
    showBestPerformance() {
      const value = this.bestPerformance[0];
      return value;
    },
    buttonTrigger() {
      if (this.checkButton === 3){
        this.checkButton = 4;
      }
      else {
        this.checkButton = 3;
      }
      return this.checkButton;
    }
  },
  callForData(){
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('profile', [
      'performanceInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};

</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfilePerformance.vue